"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vlr = exports.View = exports.PointData = exports.Header = exports.Extractor = exports.ExtraBytes = exports.Dimensions = exports.Constants = void 0;
// Note that everything here is implicitly referring to LAS 1.4 - no other
// versions are supported by these utilities.
exports.Constants = __importStar(require("./constants"));
var dimensions_1 = require("./dimensions");
Object.defineProperty(exports, "Dimensions", { enumerable: true, get: function () { return dimensions_1.Dimensions; } });
var extra_bytes_1 = require("./extra-bytes");
Object.defineProperty(exports, "ExtraBytes", { enumerable: true, get: function () { return extra_bytes_1.ExtraBytes; } });
var extractor_1 = require("./extractor");
Object.defineProperty(exports, "Extractor", { enumerable: true, get: function () { return extractor_1.Extractor; } });
var header_1 = require("./header");
Object.defineProperty(exports, "Header", { enumerable: true, get: function () { return header_1.Header; } });
var point_data_1 = require("./point-data");
Object.defineProperty(exports, "PointData", { enumerable: true, get: function () { return point_data_1.PointData; } });
var view_1 = require("./view");
Object.defineProperty(exports, "View", { enumerable: true, get: function () { return view_1.View; } });
var vlr_1 = require("./vlr");
Object.defineProperty(exports, "Vlr", { enumerable: true, get: function () { return vlr_1.Vlr; } });
